import { useState } from 'react';
import { AnalyzerReportsProvider } from '@Context/AnalyzerReportsContext';
import { Sidebar } from '@Components/analyzer-reports/Sidebar';
import { ReportList } from '@Components/analyzer-reports/ReportList';
import { useAuth } from '@Context/CognitoAuthProvider';

export default function AnalyzerReportsPage() {
  const { user } = useAuth();
  const [expandedWeek, setExpandedWeek] = useState<string[]>([]);

  if (!user?.profile?.jira_api_key) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="rounded-xl border border-gray-200 bg-white p-8 text-center shadow-md">
          <h2 className="text-xl font-semibold text-gray-900">
            Jira API Key Required
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            Please configure your Jira API key in your profile settings to
            access Analyzer Reports.
          </p>
        </div>
      </div>
    );
  }

  return (
    <AnalyzerReportsProvider>
      <div className="flex h-screen w-full flex-row gap-2 overflow-hidden p-6">
        <Sidebar />
        <ReportList
          expandedWeek={expandedWeek}
          setExpandedWeek={setExpandedWeek}
        />
      </div>
    </AnalyzerReportsProvider>
  );
}
